module.exports = __webpack_public_path__ + "static/media/bg-celebrate-our-love-desktop.db6d0d39.png";